const PRODUCTION_HOST_NAME = 'oba.revolut.com'
/**
 * As far as dev and prod are built by the same build in CI we cannot use environment variables on build stage,
 * because we don't know which environment build is being run for, so we have to rely on runtime check
 * by checking hostname
 */
export const isProduction = () => window.location.hostname === PRODUCTION_HOST_NAME

const SANDBOX_PARTIAL_HOST = 'sandbox-oba'
/**
 * As far as dev and prod are built by the same build in CI we cannot use environment variables on build stage,
 * because we don't know which environment build is being run for, so we have to rely on runtime check
 * by checking hostname
 */
export const isSandbox = () => window.location.host.includes(SANDBOX_PARTIAL_HOST)

const DEV_BUSINESS_APP_SANDBOX_URL = 'https://sandbox-business.revolut.com'
const DEV_BUSINESS_APP_URL = 'https://business.revolut.codes'
const PROD_BUSINESS_APP_URL = 'https://business.revolut.com'

const DEV_RETAIL_APP_URL = 'https://app.revolut.codes'
const PROD_RETAIL_APP_URL = 'https://app.revolut.com'

export const getRetailBaseUrl = () =>
  isProduction() ? PROD_RETAIL_APP_URL : DEV_RETAIL_APP_URL

export const getBusinessBaseUrl = () => {
  if (isProduction()) {
    return PROD_BUSINESS_APP_URL
  }

  if (isSandbox()) {
    return DEV_BUSINESS_APP_SANDBOX_URL
  }

  return DEV_BUSINESS_APP_URL
}
